<template>
  <div
    class="cognito-branded-shell min-h-screen bg-gray-50 text-neutral-800 antialiased"
  >
    <header
      class="cognito-branded-shell__header relative z-10 flex shrink-0 justify-center border-b border-gray-200 bg-gray-50 px-4 pb-3 pt-6"
    >
      <CognitoLogoMark />
    </header>
    <!-- relative: BarLoader with contained=true is position:absolute and fills only this area, not the header (logo stays clear) -->
    <div
      class="cognito-branded-shell__main relative z-0 flex min-h-0 w-full flex-1 flex-col items-center justify-center px-4 pb-12"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import CognitoLogoMark from "./CognitoLogoMark.vue";

export default defineComponent({
  name: "CognitoBrandedShell",
  components: { CognitoLogoMark },
});
</script>

<style scoped>
.cognito-branded-shell {
  color-scheme: light;
  display: grid;
  grid-template-rows: auto 1fr;
  min-height: max(100vh, 878px);
  margin: 0;
  width: 100%;
  line-height: 18.4px;
}
</style>
